import './AddField.scss';
import { useState } from 'react';
import { postField, fetchData } from '../../APICalls/GetRequests';
import { changeFieldName } from '../../APICalls/PutRequests';
import Cookies from 'js-cookie';

const AddField = ({ setSideNavFields }) => {
    const initialFormData = {
        housing_id: '',
        name: ''
    };

    const [formData, setFormData] = useState(initialFormData);

    const createField = async () => {
        try {
            const sessionKey = Cookies.get('session_key');

            // 1️⃣ Create field
            const createdField = await postField(formData, sessionKey);

            // ⚠️ make sure your API returns the new field ID
            const newFieldId = createdField.id;

            // 2️⃣ Immediately update name (only if name exists)
            if (formData.name && newFieldId) {
                await changeFieldName(
                    newFieldId,
                    { name: formData.name },
                    sessionKey
                );
            }

            // 3️⃣ Refresh sidebar fields
            const updatedFields = await fetchData('fieldnames', sessionKey);
            setSideNavFields(updatedFields);

        } catch (error) {
            console.log(error);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        createField();
        setFormData(initialFormData);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    return (
        <div className='AddField'>
            <form className='add-form-container' onSubmit={handleSubmit}>
                <h1>Add Field</h1>

                {/* Name Input (NEW) */}
                <div className="form-group">
                    <label>Name:</label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Enter field name"
                    />
                </div>

                {/* Housing ID */}
                <div className="form-group">
                    <label>Housing ID:</label>
                    <input
                        type="text"
                        name="housing_id"
                        value={formData.housing_id}
                        onChange={handleChange}
                    />
                </div>

                <button type="submit">Submit</button>
            </form>
        </div>
    );
};

export default AddField;